import { z } from "zod";

export const discountNotAvailableCauseSchema = z.enum([
  "REVIEW_DECLINED",
  "OPPORTUNITY_LOST",
  "LAST_ORDER_DATE_PASSED",
  "UNDER_REVIEW",
]);

export type DiscountNotAvailableCause = z.infer<typeof discountNotAvailableCauseSchema>;
